import { useState, useMemo } from "react";
import { TIMEZONE, sortByCustomOrder, sortByKey, normalizeString } from "../utils/trackingUtils";

const useSortedEntries = (entries, { tab, activeDay, filterProject, searchQuery, projects }) => {
	const [sortConfig, setSortConfig] = useState({ key: null, direction: "desc" });

	const filteredEntries = useMemo(() => {
		let filtered = entries.filter((e) => (tab === 0 ? e.date === activeDay.tz(TIMEZONE).format("YYYY-MM-DD") : true));

		if (filterProject) {
			filtered = filtered.filter((entry) => entry.projectId === filterProject.id);
		}

		if (searchQuery) {
			const search = normalizeString(searchQuery);
			filtered = filtered.filter((entry) => {
				const project = projects.find((p) => p.id === entry.projectId);
				return (
					normalizeString(project?.name).includes(search) ||
					normalizeString(entry.task?.name).includes(search) ||
					normalizeString(entry.comments).includes(search)
				);
			});
		}

		if (sortConfig.key !== null) {
			filtered.sort((a, b) => sortByKey(a, b, sortConfig.key, sortConfig.direction, projects));
		} else if (tab === 1) {
			filtered.sort((a, b) => {
				const dateCompare = new Date(b.date) - new Date(a.date);
				if (dateCompare !== 0) return dateCompare;
				return sortByCustomOrder(a, b);
			});
		} else {
			filtered.sort(sortByCustomOrder);
		}

		if (tab === 1) {
			const tempEntries = filtered.filter((e) => e.tempId);
			const otherEntries = filtered.filter((e) => !e.tempId);
			return [...tempEntries, ...otherEntries];
		}

		return filtered;
	}, [entries, tab, activeDay, filterProject, searchQuery, sortConfig, projects]);

	const requestSort = (key) => {
		if (sortConfig.key === key) {
			setSortConfig({ key, direction: sortConfig.direction === "asc" ? "desc" : "asc" });
		} else {
			setSortConfig({ key, direction: "asc" });
		}
	};

	const isDragDisabled = sortConfig.key !== null || tab === 1;

	return {
		filteredEntries,
		sortConfig,
		requestSort,
		isDragDisabled,
	};
};

export default useSortedEntries;
